import ApiService from "../api.service"

function selectListQuery(data) {
  const params = new URLSearchParams()
  Object.keys(data).forEach((item) => {
    const value = data[item]
    if (value === undefined || value === null)
      return
    if (Array.isArray(value)) {
      value.forEach(item2 => params.append(item, item2))
    } else {
      params.append(item, value)
    }
  })
  return params.toString()
}

const ManualService = {
  LanguageSelectList() {
    return ApiService.get("/manual/LanguageSelectList")
  },
  SwiftComissionTypeSelectList() {
    return ApiService.get("/manual/SwiftComissionTypeSelectList")
  },
  ModuleSelectList() {
    return ApiService.get("/manual/ModuleSelectList")
  },
  RegionSelectList() {
    return ApiService.get("/manual/RegionSelectList")
  },
  CountrySelectList() {
    return ApiService.get("/manual/CountrySelectList")
  },
  DistrictSelectList(regionId) {
    return ApiService.get(`/manual/DistrictSelectList?regionId=${regionId}`)
  },
  DistrictBranchSelectList(brId) {
    return ApiService.get(`/manual/DistrictBranchSelectList?brId=${brId}`)
  },
  RoleSelectList(data) {
    return ApiService.get2(`/manual/RoleSelectList`, data)
  },
  OrganizationSelectList(
    IsInitQuery,
    Ids,
    PageSize,
    Search,
    SortBy,
    OrderType,
    Page,
  ) {
    let ids = ""
    for (let i = 0; i < Ids.length; i++) {
      ids += `Ids=${Ids[i]}&`
    }
    return ApiService.get(
      `/manual/OrganizationSelectList?IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}`,
    )
  },
  BranchSelectList() {
    return ApiService.get(`/manual/BranchSelectList`)
  },
  TableSelectList() {
    return ApiService.get(`/manual/TableSelectList`)
  },
  ScheduleSelectList() {
    return ApiService.get(`/manual/ScheduleSelectList`)
  },
  BranchSelectList2(data) {
    return ApiService.get2(`/manual/BranchSelectList`, data)
  },
  BranchSelectListWithFilter(data) {
    return ApiService.get(`/manual/BranchSelectList`, { params: data })
  },
  CentralBranchSelectList(regionId) {
    return ApiService.get(
      `/manual/BranchSelectList?isSentralBranch=true&regionId=${regionId}`,
    )
  },
  AllBranchSelectList() {
    return ApiService.get(
      `/manual/BranchSelectList?notAutoFilterBySelfBranch=${true}`,
    )
  },
  BranchByRegionSelectList() {
    return ApiService.get(`/manual/BranchByRegionSelectList`)
  },
  PositionClassSelectList() {
    return ApiService.get(`/manual/PositionClassSelectList`)
  },
  PositionClassTypeSelectList() {
    return ApiService.get(`/manual/PositionClassTypeSelectList`)
  },
  BankTypeSelectList() {
    return ApiService.get(`/manual/BankTypeSelectList`)
  },
  StateSelectList() {
    return ApiService.get(`/manual/StateSelectList`)
  },
  StatusSelectList() {
    return ApiService.get(`/manual/StatusSelectList`)
  },
  CurrencySelectList(IsExcludeNational, IsExcludeEmptyBanknote, data) {
    return ApiService.get("/manual/CurrencySelectList", {
      params: {
        IsExcludeNational: IsExcludeNational == undefined ? false : IsExcludeNational,
        IsExcludeEmptyBanknote:
          IsExcludeEmptyBanknote == undefined ? false : IsExcludeEmptyBanknote,
        ...data,
      },
    })
  },
  BankSelectList() {
    return ApiService.get(`/manual/BankSelectList`)
  },
  IdentityDocumentTypeSelectList() {
    return ApiService.get(`/manual/IdentityDocumentTypeSelectList`)
  },
  GenderSelectList() {
    return ApiService.get(`/manual/GenderSelectList`)
  },
  NationalitySelectList() {
    return ApiService.get(`/manual/NationalitySelectList`)
  },
  CitizenshipSelectList() {
    return ApiService.get(`/manual/CitizenshipSelectList`)
  },
  DepartmentSelectList(BranchId) {
    return ApiService.get(`/manual/DepartmentSelectList?BranchId=${BranchId}`)
  },
  PositionSelectList(BranchId) {
    return ApiService.get(`/manual/PositionSelectList?BranchId=${BranchId}`)
  },
  CashboxSelectList(DepartmentId, BranchId, IsNeedBelongsToVash) {
    return ApiService.get(
      `/manual/CashboxSelectList?DepartmentId=${DepartmentId}&BranchId=${BranchId}&IsNeedBelongsToVash=${
        IsNeedBelongsToVash == undefined ? false : IsNeedBelongsToVash
      }`,
    )
  },
  BanknoteSelectList(CurrencyId) {
    return ApiService.get(`/manual/BanknoteSelectList?CurrencyId=${CurrencyId}`)
  },
  WorthTypeSelectList() {
    return ApiService.get(`/manual/WorthTypeSelectList`)
  },
  OkedSelectList(IsInitQuery, Ids, PageSize, Search, SortBy, OrderType, Page) {
    let ids = ""
    for (let i = 0; i < Ids.length; i++) {
      ids += `Ids=${Ids[i]}&`
    }
    return ApiService.get(
      `/manual/OkedSelectList?IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}`,
    )
  },
  AccountsPlanSelectList(
    IsInitQuery,
    Ids,
    PageSize,
    Search,
    SortBy,
    OrderType,
    Page,
  ) {
    let ids = ""
    for (let i = 0; i < Ids.length; i++) {
      ids += `Ids=${Ids[i]}&`
    }
    return ApiService.get(
      `/manual/AccountsPlanSelectList?IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}`,
    )
  },
  BankSelectList(
    IsInitQuery,
    Ids,
    PageSize,
    Search,
    SortBy,
    OrderType,
    Page,
    bankCategoryId,
  ) {
    let ids = ""
    if (Ids.length > 0) {
      for (let i = 0; i < Ids.length; i++) {
        ids += `Ids=${Ids[i]}&`
      }
    }
    if (bankCategoryId == undefined) {
      bankCategoryId = ""
    }
    return ApiService.get(
      `/manual/BankSelectList?IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}&bankCategoryId=${bankCategoryId}`,
    )
  },
  CollectionBagSelectList(
    IsInitQuery,
    Ids,
    PageSize,
    Search,
    SortBy,
    OrderType,
    Page,
  ) {
    let ids = ""
    for (let i = 0; i < Ids.length; i++) {
      ids += `Ids=${Ids[i]}&`
    }
    return ApiService.get(
      `/manual/CollectionBagSelectList?IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}`,
    )
  },
  PaymentSymbolSelectList(
    AllowTransactionId,
    PaymentSymbolName,
    CurrencyId,
    SettlementAccountId,
  ) {
    if (AllowTransactionId == undefined) {
      AllowTransactionId = ""
    }
    if (PaymentSymbolName == undefined) {
      PaymentSymbolName = ""
    }
    if (CurrencyId == undefined) {
      CurrencyId = ""
    }
    if (SettlementAccountId == undefined || SettlementAccountId == 0) {
      SettlementAccountId = ""
    }
    return ApiService.get(
      `/manual/PaymentSymbolSelectList?AllowTransactionId=${AllowTransactionId}&PaymentSymbolName=${PaymentSymbolName}&CurrencyId=${CurrencyId}&SettlementAccountId=${SettlementAccountId}`,
    )
  },
  PaymentSymbolPurposeSelectList(
    PaymentSymbolId,
    PaymentSymbolPurposeName,
    IsNeedPaymentSymbolEmpty,
  ) {
    if (PaymentSymbolPurposeName == undefined) {
      PaymentSymbolPurposeName = ""
    }
    if (IsNeedPaymentSymbolEmpty == undefined) {
      IsNeedPaymentSymbolEmpty = false
    }
    if (PaymentSymbolId == undefined) {
      PaymentSymbolId = ""
    }
    return ApiService.get(
      `/manual/PaymentSymbolPurposeSelectList?PaymentSymbolId=${PaymentSymbolId}&PaymentSymbolPurposeName=${PaymentSymbolPurposeName}&IsNeedPaymentSymbolEmpty=${IsNeedPaymentSymbolEmpty}`,
    )
  },
  TableSelectList(onlyMainDocs = false) {
    return ApiService.get("/manual/TableSelectList", {
      params: {
        onlyMainDocs,
      },
    })
  },
  UnitOfMeasureSelectList() {
    return ApiService.get("/manual/UnitOfMeasureSelectList")
  },
  DirectionTypeSelectList() {
    return ApiService.get("/manual/DirectionTypeSelectList")
  },
  GetOrganizationSettings() {
    return ApiService.get("/manual/GetOrganizationSettings")
  },
  StrictReportingFormSelectList(AccountsPlanId) {
    return ApiService.get(
      `/manual/StrictReportingFormSelectList${AccountsPlanId ? `?AccountsPlanId=${AccountsPlanId}` : ""}`,
    )
  },
  UserSelectList(
    DepartmentId,
    PositionId,
    BranchId,
    CashboxId,
    PositionClassId,
    IsInitQuery,
    Ids,
    PageSize,
    Search,
    SortBy,
    OrderType,
    Page,
    RootBranchId,
  ) {
    let ids = ""
    for (let i = 0; i < Ids.length; i++) {
      ids += `Ids=${Ids[i]}&`
    }
    return ApiService.get(
      `/manual/UserSelectList?DepartmentId=${DepartmentId}&PositionId=${PositionId}&BranchId=${BranchId}&CashboxId=${CashboxId}&PositionClassId=${PositionClassId}&IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}&RootBranchId=${RootBranchId}`,
    )
  },
  SettlementAccountSelectList(data) {
    return ApiService.post(`/manual/SettlementAccountSelectList`, data)
  },
  VirtualSettlementAccountSelectList(data) {
    return ApiService.post(`/manual/VirtualSettlementAccountSelectList`, data)
  },
  AllowTransactionSelectList(
    DocumentId,
    AllowTransactionTypeId,
    DbCashboxId,
    CtCashboxId,
    CreditId,
    DebitId,
    DbUserId,
    CtUserId,
    IsInitQuery,
    Ids,
    PageSize,
    Search,
    SortBy,
    OrderType,
    Page,
    BankCategoryId,
    strictReportingFormId,
    IsIncome,
    ReportTableId,
  ) {
    let ids = ""
    for (let i = 0; i < Ids.length; i++) {
      ids += `Ids=${Ids[i]}&`
    }
    if (DbCashboxId == undefined)
      DbCashboxId = ""
    if (CtCashboxId == undefined)
      CtCashboxId = ""
    if (DebitId == undefined)
      DebitId = ""
    if (CreditId == undefined)
      CreditId = ""
    if (DbUserId == undefined)
      DbUserId = ""
    if (CtUserId == undefined)
      CtUserId = ""
    if (BankCategoryId == undefined)
      BankCategoryId = ""
    if (strictReportingFormId == undefined)
      strictReportingFormId = ""
    if (IsIncome == undefined)
      IsIncome = false
    if (ReportTableId == undefined)
      ReportTableId = ""
    return ApiService.get(
      `/manual/AllowTransactionSelectList?DocumentId=${DocumentId}&AllowTransactionTypeId=${AllowTransactionTypeId}&DbCashboxId=${DbCashboxId}&CtCashboxId=${CtCashboxId}&CreditId=${CreditId}&DebitId=${DebitId}&DbUserId=${DbUserId}&CtUserId=${CtUserId}&IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}&BankCategoryId=${BankCategoryId}&strictReportingFormId=${strictReportingFormId}&IsIncome=${IsIncome}&ReportTableId=${ReportTableId}`,
    )
  },
  ContractorSelectList(
    ShowAllContractor,
    IsInitQuery,
    Ids,
    PageSize,
    Search,
    SortBy,
    OrderType,
    Page,
  ) {
    let ids = ""
    for (let i = 0; i < Ids.length; i++) {
      ids += `Ids=${Ids[i]}&`
    }
    return ApiService.get(
      `/manual/ContractorSelectList?IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}&ShowAllContractor=${
        ShowAllContractor == undefined ? true : ShowAllContractor
      }`,
    )
  },
  CollectorSelectList(
    IsInitQuery,
    Ids,
    PageSize,
    Search,
    SortBy,
    OrderType,
    Page,
  ) {
    let ids = ""
    for (let i = 0; i < Ids.length; i++) {
      ids += `Ids=${Ids[i]}&`
    }
    return ApiService.get(
      `/manual/CollectorSelectList?IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}`,
    )
  },
  IncomeCollectionBagTableSelectList(
    Search,
    SortBy,
    OrderType,
    Page,
    PageSize,
    IsOnlyBagsHasAmount,
  ) {
    return ApiService.get(
      `/manual/IncomeCollectionBagTableSelectList?Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}&PageSize=${PageSize}&IsOnlyBagsHasAmount=${IsOnlyBagsHasAmount}`,
    )
  },
  ChangeMoneyServiceTariffTypeSelectList() {
    return ApiService.get(`/manual/ChangeMoneyServiceTariffTypeSelectList`)
  },
  DownloadBanknotePicture(id) {
    return ApiService.print(`/manual/DownloadBanknotePicture/${id}`)
  },
  DownloadBanknotePictureByBanknoteId(banknoteId) {
    return ApiService.print(`/manual/DownloadBanknotePicture/${banknoteId}`)
  },
  PaymentMethodSelectList() {
    return ApiService.get(`/manual/PaymentMethodSelectList`)
  },
  PaymentTypeSelectList(PaymentMethodId) {
    if (PaymentMethodId == undefined) {
      PaymentMethodId = ""
    }
    return ApiService.get(
      `/manual/PaymentTypeSelectList?PaymentMethodId=${PaymentMethodId}`,
    )
  },
  ExchangeTypeSelectList() {
    return ApiService.get(`/manual/ExchangeTypeSelectList`)
  },
  CurrencyRateSelectList(CurrencyId, Date, Amount) {
    if (Amount == undefined) {
      Amount = 0
    }
    return ApiService.get(
      `/manual/CurrencyRateSelectList?CurrencyId=${CurrencyId}&Date=${Date}&Amount=${Amount}`,
    )
  },
  AllowTransactionTypeSelectList() {
    return ApiService.get(`/manual/AllowTransactionTypeSelectList`)
  },
  DownloadCurrencyPicture(id) {
    return ApiService.print(`/manual/DownloadCurrencyPicture/${id}`)
  },
  DownloadCurrencyPictureByCurrencyId(currencyId) {
    return ApiService.print(
      `/manual/DownloadCurrencyPictureByCurrencyId/${currencyId}`,
    )
  },
  ClientInterestPayerSelectList() {
    return ApiService.get(`/manual/ClientInterestPayerSelectList`)
  },
  ClientPaymentTypeSelectList(PaymentMethodId) {
    return ApiService.get(
      `/manual/ClientPaymentTypeSelectList?PaymentMethodId=${PaymentMethodId}`,
    )
  },
  ClientPaymentMethodSelectList() {
    return ApiService.get(`/manual/ClientPaymentMethodSelectList`)
  },
  ClientContractSelectList(
    PaymentTypeId,
    SubTypeId,
    RegionId,
    IsInitQuery,
    Ids,
    PageSize,
    Search,
    SortBy,
    OrderType,
    Page,
  ) {
    let ids = ""
    for (let i = 0; i < Ids.length; i++) {
      ids += `Ids=${Ids[i]}&`
    }
    return ApiService.get(
      `/manual/ClientContractSelectList?PaymentTypeId=${PaymentTypeId}&SubTypeId=${SubTypeId}&RegionId=${RegionId}&IsInitQuery=${IsInitQuery}&${ids}PageSize=${PageSize}&Search=${Search}&SortBy=${SortBy}&OrderType=${OrderType}&Page=${Page}`,
    )
  },
  ClientPaymentSubTypeSelectList(ClientPaymentTypeId) {
    return ApiService.get(
      `/manual/ClientPaymentSubTypeSelectList?ClientPaymentTypeId=${ClientPaymentTypeId}`,
    )
  },
  IabsDocumentTypeSelectList() {
    return ApiService.get(`/manual/IabsDocumentTypeSelectList`)
  },
  VirtualSettlementAccountTypeSelectList() {
    return ApiService.get(`/manual/VirtualSettlementAccountTypeSelectList`)
  },
  AccountsPlanTypeSelectList() {
    return ApiService.get(`/manual/AccountsPlanTypeSelectList`)
  },
  GetGspPersonInfo(data) {
    return ApiService.post(`/gsp/GetGspPersonInfo`, data)
  },
  BanknoteDetailTypeSelectList() {
    return ApiService.get(`/manual/BanknoteDetailTypeSelectList`)
  },
  BankCategorySelectList() {
    return ApiService.get(`/manual/BankCategorySelectList`)
  },
  DocumentControlTypeSelectList() {
    return ApiService.get(`/manual/DocumentControlTypeSelectList`)
  },
  PaymentSystemSelectList() {
    return ApiService.get(`/manual/PaymentSystemSelectList`)
  },
  ChangeMoneyDirectionTypeSelectList() {
    return ApiService.get(`/manual/ChangeMoneyDirectionTypeSelectList`)
  },
  ChangeMoneyServiceTypeSelectList() {
    return ApiService.get(`/manual/ChangeMoneyServiceTypeSelectList`)
  },
  ChangeMoneyTypeSelectList() {
    return ApiService.get(`/manual/ChangeMoneyTypeSelectList`)
  },
  TransferTypeSelectList() {
    return ApiService.get(`/manual/TransferTypeSelectList`)
  },
  TransferSystemTypeSelectList(TransferTypeId) {
    return ApiService.get(
      `/manual/TransferSystemTypeSelectList?TransferTypeId=${TransferTypeId}`,
    )
  },
  CurrencyExchangeAllowTransactionTypeSelectList() {
    return ApiService.get(
      `/manual/CurrencyExchangeAllowTransactionTypeSelectList`,
    )
  },
  DownloadTransferSystemTypePictureId(transfersystemtypeId) {
    return ApiService.print(
      `/manual/DownloadTransferSystemTypePictureId/${transfersystemtypeId}`,
    )
  },
  ClientInterestPayerSelectList() {
    return ApiService.get(`/manual/ClientInterestPayerSelectList`)
  },
  ClientPaymentAllowTransactionTypeSelectList() {
    return ApiService.get(`/manual/ClientPaymentAllowTransactionTypeSelectList`)
  },
  BlankTypeSelectList() {
    return ApiService.get(`/manual/BlankTypeSelectList`)
  },
  FileExtensionSelectList() {
    return ApiService.get(`/manual/FileExtensionSelectList`)
  },

  FixingDocumentOperationTypeSelectList() {
    return ApiService.get(`/manual/FixingDocumentOperationTypeSelectList`)
  },
  ManagementStructureLimitTypeSelectList() {
    return ApiService.get(`/manual/ManagementStructureLimitTypeSelectList`)
  },
  UserAccountsPlanRestrictionTypeSelectList() {
    return ApiService.get(`/manual/UserAccountsPlanRestrictionTypeSelectList`)
  },
  ReportTableSelectList() {
    return ApiService.get(`/manual/ReportTableSelectList`)
  },
  UserSelectListForAtm(data) {
    return ApiService.get(`/manual/UserSelectListForAtm?${selectListQuery(data)}`)
  },
  UserSelectListForAtmWithManyPositionClass(data) {
    return ApiService.get(
      `/manual/UserSelectListForAtmWithManyPositionClass?${selectListQuery(data)}`,
    )
  },
  SpecialGroupMemberTypeSelectList(specialGroupTypeId) {
    return ApiService.get(
      `/manual/SpecialGroupMemberTypeSelectList?specialGroupTypeId=${specialGroupTypeId}`,
    )
  },
  SpecialGroupTypeSelectList() {
    return ApiService.get(`/manual/SpecialGroupTypeSelectList`)
  },
  RecountDeviceTypeSelectList() {
    return ApiService.get(`/manual/RecountDeviceTypeSelectList`)
  },
  RecountDeviceModelSelectList() {
    return ApiService.get(`/manual/RecountDeviceModelSelectList`)
  },
  DeviceTypeSelectList() {
    return ApiService.get(`/manual/DeviceTypeSelectList`)
  },
  DeviceModelSelectList(deviceTypeId) {
    return ApiService.get(
      `/manual/DeviceModelSelectList?deviceTypeId=${deviceTypeId}`,
    )
  },
  LoginSystemTypeSelectList() {
    return ApiService.get(`/manual/LoginSystemTypeSelectList`)
  },
  RecountDeviceSelectList(recountDeviceModelId, recountDeviceTypeId, onDate) {
    return ApiService.get(
      `/manual/RecountDeviceSelectList?recountDeviceModelId=${recountDeviceModelId}&recountDeviceTypeId=${recountDeviceTypeId}&onDate=${onDate}`,
    )
  },
  CorrectionTypeSelectList() {
    return ApiService.get(`/manual/CorrectionTypeSelectList`)
  },
  CurrencySelectListForAtm(
    CashboxId,
    IsRequirement,
    IsExcludeNational,
    IsExcludeEmptyBanknote,
  ) {
    return ApiService.get(
      `/manual/CurrencySelectListForAtm?CashboxId=${CashboxId}&IsRequirement=${IsRequirement}&IsExcludeNational=${IsExcludeNational}&IsExcludeEmptyBanknote=${IsExcludeEmptyBanknote}`,
    )
  },
  AppointmentEmployeeTypeSelectList() {
    return ApiService.get(`/manual/AppointmentEmployeeTypeSelectList`)
  },
  BookTypeSelectList() {
    return ApiService.get(`/manual/BookTypeSelectList`)
  },
  HolidayTypeSelectList() {
    return ApiService.get("/manual/HolidayTypeSelectList")
  },
  SmsTextSelectList() {
    return ApiService.get("/manual/SmsTextSelectList")
  },
  AtmDeviceTypeSelectList() {
    return ApiService.get("/manual/AtmDeviceTypeSelectList")
  },
  PreciousMetalTypeSelectList() {
    return ApiService.get("/manual/PreciousMetalTypeSelectList")
  },
  PreciousMetalBaseTypeSelectList() {
    return ApiService.get("/manual/PreciousMetalBaseTypeSelectList")
  },
  PreciousMetalDeviceSelectList(data = {}) {
    return ApiService.get2("/manual/PreciousMetalDeviceSelectList", data)
  },
  CustomerSelectList(data) {
    return ApiService.get2("/manual/CustomerSelectList", data)
  },
  PreciousMetalComissionTypeSelectList() {
    return ApiService.get("/manual/PreciousMetalComissionTypeSelectList")
  },
  AppSelectList() {
    return ApiService.get("/manual/AppSelectList")
  },
  ClientFieldTypeSelectList() {
    return ApiService.get("/manual/ClientFieldTypeSelectList")
  },
  CashRetailServiceTypeSelectList(withMainPayments) {
    return ApiService.get2("/manual/CashRetailServiceTypeSelectList", {
      withMainPayments,
    })
  },
  ClientPaymentTypeGroupSelectList() {
    return ApiService.get("/manual/ClientPaymentTypeGroupSelectList")
  },
  ClientTypeSelectList() {
    return ApiService.get("/manual/ClientTypeSelectList")
  },
  JuridicalClientDocumentTypeSelectList(params) {
    return ApiService.get("/manual/JuridicalClientDocumentTypeSelectList", {
      params,
    })
  },
  SwiftDocumentTypeSelectList() {
    return ApiService.get("/manual/SwiftDocumentTypeSelectList")
  },
  JuridicalClientOperationTypeSelectList() {
    return ApiService.get("/manual/JuridicalClientOperationTypeSelectList")
  },
  AwardTypeSelectList(governmentDecreeId, isOnlyActive = true) {
    return ApiService.get(`/manual/AwardTypeSelectList`, {
      params: {
        governmentDecreeId,
        isOnlyActive,
      },
    })
  },
  GovernmentDecreeSelectList(awardTypeId, isOnlyActive = true) {
    return ApiService.get("/manual/GovernmentDecreeSelectList", {
      params: { awardTypeId, isOnlyActive },
    })
  },
  IhmaCommunalTypeSelectList() {
    return ApiService.get("/manual/IhmaCommunalTypeSelectList")
  },
  IhmaPaymentTypeSelectList() {
    return ApiService.get("/manual/IhmaPaymentTypeSelectList")
  },
  IhmaPaymentSubTypeSelectList(ihmaPaymentTypeId) {
    return ApiService.get(
      `/manual/IhmaPaymentSubTypeSelectList?ihmaPaymentTypeId=${ihmaPaymentTypeId}`,
    )
  },
  AutoCommunalTypeSelectList() {
    return ApiService.get("/manual/AutoCommunalPaymentTypeSelectList")
  },
  AutoPaymentTypeSelectList() {
    return ApiService.get("/manual/AutoPaymentTypeSelectList")
  },
  AutoPaymentSubTypeSelectList(AutoPaymentTypeId) {
    if (!AutoPaymentTypeId) {
      AutoPaymentTypeId = ""
    }
    return ApiService.get(
      `/manual/AutoPaymentSubTypeSelectList?AutoPaymentTypeId=${AutoPaymentTypeId}`,
    )
  },
  AutoPaymentSettingSelectList(
    autoPaymentTypeId,
    autoCommunalTypeId,
    clientPaymentMethodId,
    autoPaymentSubTypeId,
  ) {
    return ApiService.get(
      `/manual/AutoPaymentSettingSelectList?autoPaymentTypeId=${autoPaymentTypeId}&autoCommunalTypeId=${autoCommunalTypeId}&clientPaymentMethodId=${clientPaymentMethodId}&autoPaymentSubTypeId=${autoPaymentSubTypeId}`,
    )
  },
  JuridicalClientOperationStepTypeSelectList() {
    return ApiService.get("/manual/JuridicalClientOperationStepTypeSelectList")
  },
  InternalValuableMovementDocumentTypeSelectList() {
    return ApiService.get(
      "/manual/InternalValuableMovementDocumentTypeSelectList",
    )
  },
  CurrencyConversionTypeSelectList() {
    return ApiService.get("/manual/CurrencyConversionTypeSelectList")
  },
  ConversionAccountTypeSelectList(currencyConversionTypeId) {
    return ApiService.get(`/manual/CurrencyConversionAccountTypeSelectList`, {
      params: {
        currencyConversionTypeId,
      },
    })
  },
  CurrencyConversionPurposeTypeSelectList(params = {}) {
    return ApiService.get("/manual/CurrencyConversionPurposeTypeSelectList", {
      params,
    })
  },
  CurrencySourceTypeSelectList() {
    return ApiService.get("/manual/CurrencyConversionSourceTypeSelectList")
  },
  CurrencyExchangeIdentificatorSelectList(data) {
    return ApiService.get("/manual/CurrencyExchangeIdentificatorSelectList", { params: data })
  },
  AccountPatternSelectList() {
    return ApiService.get("/manual/AccountPatternSelectList")
  },
}
export default ManualService
